import React from 'react';

const BUTTON_BASE =
    'flex flex-row items-center justify-center object-contain h-12 py-2 px-4 gap-2';

const Button = ({color, size, children, disabled, onClick}) => {

    const BUTTON_COLOR = {
        PRIMARY: 'bg-yellow-500 text-white rounded-md hover:bg-yellow-600 active:bg-yellow-700',
        SECONDARY: 'bg-white text-gray-700 border b-white rounded-md border-gray-100 hover:bg-gray-100 hover:text-gray-700 active:bg-gray-100',
        DEFAULT: 'bg-transparent text-gray-700',
        DISABLED: 'bg-gray-50 text-gray-400 border-0 b-gray-300 rounded-md'
    }

    const BUTTON_SIZE = {
        SM: 'ft-sm',
        SMI: 'ft-sm w-12 shrink-0 px-2',
        LG: 'ft-sm',
        LGI: 'ft-sm px-3',
        FULL: 'w-full ft-sm'
    }
    const colorClassName = BUTTON_COLOR[color || 'PRIMARY']
    const sizeClassName = BUTTON_SIZE[size || 'SM']

    return (
        <button type={'button'}
                className={BUTTON_BASE + ' ' + sizeClassName + ' ' + colorClassName}
                disabled={disabled} onClick={onClick}
        >
            {children}
        </button>
    );
};

export default Button;
